<template>
    <div class="posts-wrapper">
        <div class="white-rounded-box mr-4 ml-5 sm:ml-0">
            <div class="flex flex-col">
                <h3 class="mx-auto mt-4 ">Organization News</h3>
                <div v-if="posts.length">
                    <div
                        class="flex w-full h-fit mt-2 justify-center"
                        v-for="(post, i) in posts"
                        :key="i"
                    >
                        <organization-post :post="post" />
                    </div>
                </div>
                <div
                    class="flex justify-between items-center text-center my-auto h-20"
                    v-else
                >
                    <p class="mx-auto">No News Posted</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrganizationPost from "./OrganizationPost.vue";
export default {
    props: ["posts"],
    components: {
        OrganizationPost,
    },
};
</script>
<style scoped>
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    width: 10px;
    border-radius: 10px;
}
</style>
